// Code generated by protoc-gen-ts_proto_ipc_plugin. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto_internal_plugin  v0.1.20
//   protoc               v6.30.2
// source: services/documents/document.proto

/* eslint-disable */
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GrpcWebErrrHandlingImpl } from "src/app/shared/services/grpc-client";
import { EmptyResponse } from "../../common/messages/messages";
import {
  Document,
  FileChunkResponse,
  GetFileRequest,
  GetFileUrlRequest,
  GetFileUrlResponse,
  UploadChunkRequest,
  UploadFileRequest,
  UploadFileResponse,
  VerifyFileUploadRequest,
  VerifyUploadedChunksRequest,
} from "./document";

import { DocumentServiceClientImpl } from "./document";

@Injectable({ providedIn: "root" })
export class DocumentServiceSpa {
  constructor(private _rpc: GrpcWebErrrHandlingImpl) {}
  getFile(request: GetFileRequest): Observable<FileChunkResponse> {
    const client = new DocumentServiceClientImpl(this._rpc);
    return client.getFile(request);
  }
  async getFileUrl(request: GetFileUrlRequest): Promise<GetFileUrlResponse> {
    const client = new DocumentServiceClientImpl(this._rpc);
    return await client.getFileUrl(request);
  }
  async uploadChunk(request: UploadChunkRequest): Promise<EmptyResponse> {
    const client = new DocumentServiceClientImpl(this._rpc);
    return await client.uploadChunk(request);
  }
  async verifyUploadedChunks(request: VerifyUploadedChunksRequest): Promise<Document> {
    const client = new DocumentServiceClientImpl(this._rpc);
    return await client.verifyUploadedChunks(request);
  }
  async uploadFile(request: UploadFileRequest): Promise<UploadFileResponse> {
    const client = new DocumentServiceClientImpl(this._rpc);
    return await client.uploadFile(request);
  }
  async verifyUploadFile(request: VerifyFileUploadRequest): Promise<Document> {
    const client = new DocumentServiceClientImpl(this._rpc);
    return await client.verifyUploadFile(request);
  }
}
